module.exports = __webpack_public_path__ + "media/חמור.629ddab8.mp3";